<template>
  <div :class="['card', getBgClass, getTextClass, 'mb-4','text-light']">
    <div class="card-header" v-html="header"></div>
    <div class="card-body">
      <h5 class="card-title" v-html="title"></h5>
      <div class="card-text" v-html="text"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Card',
  computed: {
    getBgClass () {
      return 'bg-' + this.bgclass
    },
    getTextClass () {
      return 'text-' + this.textclass
    }
  },
  props: {
    test: String,
    bgclass: {
      type: String, // bootstrap alert-* class (ex: success, info, danger, warning, etc...),
      default: 'info'
    },
    textclass: {
      type: String,
      default: 'white'
    },
    header: String,
    title: String,
    text: String
  }
}

</script>
